<mat-horizontal-stepper class="add-menu" [linear]="false" #stepper>
    <!-- PASO 1 -->
    <mat-step>
        <mat-toolbar color="grey" fxLayout="row" fxLayoutAlign="start center">
            <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center" fxFill>
                <div class="mat-avatar" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="toolbar-line" fxLayout="row">
                        <div class="title" fxLayout="column" fxLayoutAlign="center start">
                            <h3>{{'process.documentLoad' | transloco }}{{this.headerTitle() }}</h3>
                        </div>
                    </div>
                </div>
                <button mat-icon-button (click)="cancel()" title="{{'common.closeBtn' | transloco}}">
                    <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
                </button>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-divider></mat-divider>
        <form [formGroup]="documentationTypeForm" fxFlex="grow" (submit)="next(stepper)" (reset)="cancel()">
            <div class="add-menu-form-body">
                <mat-form-field>
                    <mat-label>{{'common.company' | transloco}}</mat-label>
                    <mat-select formControlName="organizationalUnit">
                        <mat-option *ngFor="let ou of organizationalUnits" [value]="ou.id"
                            (click)="refreshDocumentationType()">
                            {{ou.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <app-autocomplete-chip [originalList]="documentationTypes"
                    [placeHolderText]="'process.selectTypeOfDocument' | transloco" (OnRemoveItem)="itemRemoved($event)"
                    (OnItemSelected)="selectDocumentationType($event)" [selectedItemsList]="selectedDocumentationTypes"
                    fxFlex="grow" fxLayout="row" fxLayoutAlign="start center">
                </app-autocomplete-chip>
            </div>
        </form>
        <div class="add-menu-form-actions">
            <button mat-raised-button color="primary" (click)="next(stepper)"
                [disabled]="!selectedDocumentationTypes || selectedDocumentationTypes.length === 0">
                {{'common.next' | transloco}}
            </button>
            <button mat-button *ngIf="showBack" (click)="back(stepper)">{{'common.last' | transloco}}</button>
            <button mat-button *ngIf="!showBack" (click)="cancel()">{{'common.cancelBtn' | transloco}}</button>
        </div>
    </mat-step>
    <!-- PASO 2 -->
    <mat-step>
        <mat-toolbar color="grey" fxLayout="row" fxLayoutAlign="start center">
            <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center" fxFill>
                <div class="mat-avatar" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="toolbar-line" fxLayout="row">
                        <div class="title" fxLayout="column" fxLayoutAlign="center start">
                            <h3>{{'process.documentLoad' | transloco}} {{this.headerTitle() }}</h3>
                        </div>
                    </div>
                </div>
                <button mat-icon-button (click)="cancel()" title="{{'common.closeBtn' | transloco}}">
                    <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
                </button>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-divider></mat-divider>
        <div class="add-menu-form-body w-table">
            <!-- EMPLOYEE-SEARCH-INPUT -->
            <div class="helper" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                    <button mat-icon-button (click)='filteredSearch("Enter")'
                        title="{{'common.reloadBtn' | transloco}}">
                        <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-redo"></mat-icon>
                    </button>
                    <div class="search-bar" fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon class="fa" fontSet="fal" fontIcon="fa-search">
                            </mat-icon>
                            <input type="search" [(ngModel)]="filterName"
                                placeholder='{{"process.searchEmployeeLbl" | transloco}}'
                                (keydown)="filteredSearch($event.key)" />
                        </div>
                        <button mat-button color="primary" [matMenuTriggerFor]="menu">
                            {{'common.advancedSearch' | transloco}}
                        </button>
                    </div>
                </div>
                <div class="actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                    <button mat-stroked-button color="primary" (click)="sendToAllPages()" [disabled]="disableSendToAll">
                        {{'common.sendToAll' | transloco}}
                    </button>
                    <app-cs-paginator *ngIf="employees?.length !== 0" [pageSize]="itemPerPage" [pageCount]="itemsCount"
                        [(pageIndex)]="pageIndex" (pageChanged)="selectedPageChanged($event)">
                    </app-cs-paginator>
                </div>
                <mat-progress-bar mode="indeterminate" *ngIf="loading && employees?.length"></mat-progress-bar>
            </div>
            <!-- Empty (app chapa) -->
            <ng-container *ngIf="employees?.length === 0 && !loading">
                <app-chapa [className]="'info-empty'" [icon]="'fa-meh'" [text]="'process.noEmployeesFound' | transloco"
                    [subText]="'process.noEmployeesFoundSubtitle' | transloco"></app-chapa>
            </ng-container>
            <!-- LOADER -->
            <div class="load-window fixed" *ngIf="loading && employees?.length === 0">
                <mat-progress-spinner style="z-index: 1" mode="indeterminate" color="primary">
                </mat-progress-spinner>
            </div>
            <!-- EMPLOYEE-SEARCH-TABLE -->
            <div class="new-table" *ngIf="employees?.length">
                <div class="mat-table" [hidden]="loading">
                    <!-- EMPLOYEE-SEARCH-TABLE_HEAD -->
                    <div class="mat-header-row sticky" fxLayout="row" fxLayoutAlign="start center">
                        <div class="mat-header-cell w-1" fxLayout="row" fxLayoutAlign="center center">
                            <mat-checkbox [(ngModel)]="allSelected" (ngModelChange)="selectAllToogle()">
                            </mat-checkbox>
                        </div>
                        <div class="w-12 multiple-selection" fxLayout="row" fxLayoutAlign="start center">
                            <div class="mat-header-cell w-6 sorteable" (click)="sortColumn(employee.nameSystemName)"
                                (keyup.enter)="sortColumn(employee.nameSystemName)" tabindex="0" fxLayout="row"
                                fxLayoutAlign="start center"
                                title="{{'common.orderByBtn' | transloco}} {{'common.nameLbl' | transloco}}">
                                <div class="sort-icon" *ngIf="orderBy === employee.nameSystemName">
                                    <mat-icon *ngIf="!orderAsc" class="fa" fontSet="fal"
                                        fontIcon="fa-arrow-down"></mat-icon>
                                    <mat-icon *ngIf="orderAsc" class="fa" fontSet="fal"
                                        fontIcon="fa-arrow-up"></mat-icon>
                                </div>
                                <span>{{'process.lastAndFirstNameLbl' | transloco}}</span>
                            </div>
                            <div class="mat-header-cell w-3 sorteable" (click)="sortColumn(employee.nroLegSystemName)"
                                (keyup.enter)="sortColumn(employee.nroLegSystemName)" tabindex="0" fxLayout="row"
                                fxLayoutAlign="start center"
                                title="{{'common.orderByBtn' | transloco}} {{'common.fileNumberLbl' | transloco}}">
                                <div class="sort-icon" *ngIf="orderBy === employee.nroLegSystemName">
                                    <mat-icon *ngIf="!orderAsc" class="fa" fontSet="fal"
                                        fontIcon="fa-arrow-down"></mat-icon>
                                    <mat-icon *ngIf="orderAsc" class="fa" fontSet="fal"
                                        fontIcon="fa-arrow-up"></mat-icon>
                                </div>
                                <span>{{'process.fileNumberLbl' | transloco}}</span>
                            </div>
                            <div class="mat-header-cell w-3 sorteable" (click)="sortColumn(employee.cuilSystemName)"
                                (keyup.enter)="sortColumn(employee.cuilSystemName)" tabindex="0" fxLayout="row"
                                fxLayoutAlign="start center"
                                title="{{'common.orderByBtn' | transloco}} {{'metadata.' + containerType?.label | transloco}}">
                                <div class="sort-icon" *ngIf="orderBy === employee.cuilSystemName">
                                    <mat-icon *ngIf="!orderAsc" class="fa" fontSet="fal"
                                        fontIcon="fa-arrow-down"></mat-icon>
                                    <mat-icon *ngIf="orderAsc" class="fa" fontSet="fal"
                                        fontIcon="fa-arrow-up"></mat-icon>
                                </div>
                                <span>{{containerType?.label}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="mat-table-body">
                        <!-- EMPLOYEE-SEARCH-TABLE-ROWS -->
                        <div class="mat-row" matRipple *ngFor="let emp of employees" fxLayout="row"
                            fxLayoutAlign="start center" (click)="selectEmployee(emp)"
                            (keyup.enter)="selectEmployee(emp)" tabindex="0"
                            [ngClass]="{'active': emp === selectedEmployee, 'selected': emp.selected, 'disabled': emp.getEmployeeClass() }">
                            <div [ngClass]="{'turn': emp.selected}" class="mat-cell w-1 off" fxLayout="row"
                                fxLayoutAlign="center center">
                                <ngx-avatar (click)="checkEmployee(emp)" [name]="emp.lastName + ' ' + emp.name"
                                    size="30" [round]="true">
                                </ngx-avatar>
                                <mat-checkbox [(ngModel)]="emp.selected" (ngModelChange)="selectedChange()">
                                </mat-checkbox>
                            </div>
                            <div class="w-12 multiple-selection" fxLayout="row" fxLayoutAlign="start center">
                                <div class="mat-cell w-6" fxLayoutAlign="start center" title=" {{ emp.name }}">
                                    <span>
                                        {{ emp.lastName }}, {{ emp.name }}
                                    </span>
                                </div>
                                <div class="mat-cell w-3" fxLayoutAlign="start center" title="{{ emp.nroLeg }}">
                                    <span>
                                        {{ emp.nroLeg }}
                                    </span>
                                </div>
                                <div class="mat-cell w-3" fxLayoutAlign="start center" title="{{ emp.cuil }}">
                                    <span>
                                        {{ emp.cuil | mask: maskSplited(containerType?.mask)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-menu-form-actions">
            <button mat-raised-button color="primary" (click)="next(stepper)">{{'common.next' | transloco}}</button>
            <button mat-button *ngIf="showBack" (click)="back(stepper)">{{'common.last' | transloco}}</button>
            <button mat-button *ngIf="!showBack" (click)="cancel()">{{'common.cancelBtn' | transloco}}</button>
        </div>
    </mat-step>
    <!-- PASO 3 -->
    <mat-step>
        <mat-toolbar color="grey" fxLayout="row" fxLayoutAlign="start center">
            <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center" fxFill>
                <div class="mat-avatar" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="toolbar-line" fxLayout="row">
                        <div class="title" fxLayout="column" fxLayoutAlign="center start">
                            <h3>{{'process.documentLoad' | transloco }}{{this.headerTitle() }}</h3>
                        </div>
                    </div>
                </div>
                <button mat-icon-button (click)="cancel()" title="{{'common.closeBtn' | transloco}}">
                    <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
                </button>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-divider></mat-divider>
        <form class="add-docs-drop" [formGroup]="sequencesForm">
            <div class="docs-drop-preview" fxLayout="row">
                <div class="add-menu-form-body" fxLayout="column" fxLayoutAlign="center stretch">
                    <app-autocomplete-chip *ngIf="selectedPerson" [originalList]="documentationTypes"
                        [placeHolderText]="'process.selectTypeOfDocument' | transloco"
                        (OnRemoveItem)="itemRemoved($event)" (OnItemSelected)="selectDocumentationType($event, true)"
                        [selectedItemsList]="selectedDocumentationTypes" fxFlex="grow" fxLayout="row"
                        fxLayoutAlign="start center">
                    </app-autocomplete-chip>

                    <mat-form-field>
                        <mat-label>{{'process.wayOfSigning.title' | transloco}}</mat-label>
                        <mat-select formControlName="sequence">
                            <mat-option *ngFor="let sec of sequences" [value]="sec.documentationSequence">
                                {{sec.documentationSequence.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="!hasPeriod">
                        <mat-label>{{'process.wayOfSigning.dateOfExpiration' | transloco}}</mat-label>
                        <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="documentationDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <button class="full-btn" mat-raised-button [color]="rrhhUploadFile ? 'warn' : 'primary'"
                        (click)="toogleCompleteFormio()" *ngIf="showOptionalFormComplete">
                        {{rrhhUploadFile ? ('process.wayOfSigning.dontCompleteForm' | transloco) :
                        ('process.wayOfSigning.completeForm' | transloco)}}
                    </button>
                    <mat-tab-group class="wizard-tabs-options" *ngIf="rrhhUploadFile"
                        (selectedIndexChange)="toggleScan()">
                        <mat-tab label="{{'process.wayOfSigning.attachDocumentationLbl' | transloco}}"
                            *ngIf="!usingFormio || (usingFormio && !isExternalFormOnly)">

                            <div class="upload-form-wrapper">
                                <app-upload-form canViewFile="false" canRemove="true" [multipleSelection]="true"
                                    acceptedExtensions="{{aceptedExtensions}}" [files]="files"
                                    [showDropZone]="!scanning && !analyzingPdf" [maxFile]="maxFiles"
                                    (fileSelected)="onSelectedFile($event, null)"
                                    (filesChanged)="onFilesChanged($event)"
                                    (seeFileDefault)="onSelectedFile($event, true)"
                                    (fileNotAllowed)="onFilesNotAlloewdAdded($event)">
                                </app-upload-form>

                                <div *ngIf="analyzingPdf" class="pdf-analyzing-loader">
                                    <mat-progress-spinner diameter="45" mode="indeterminate"
                                        color="primary"></mat-progress-spinner>
                                    <h3 class="primary-text">{{'process.addDocumentation.analyzingDocumentLbl' | transloco: { progress: pdfAnalysisProgress } }}</h3>
                                    <span>{{'process.addDocumentation.pleaseWaitLbl' | transloco}}</span>
                                </div>
                            </div>

                        </mat-tab>
                        <mat-tab label="{{'process.wayOfSigning.scanDocumentationLbl' | transloco}}"
                            *ngIf="hasWebScanning">
                            <app-web-scanner (OnScanComplete)="addScan($event)" (OnScanPage)="showScan($event)"
                                *ngIf="scanning">
                            </app-web-scanner>
                        </mat-tab>
                    </mat-tab-group>
                    <div *ngIf="adittionalsMetadatas.length > 0">
                        <h5 class="stepper-title">{{'process.wayOfSigning.data' | transloco}}</h5>
                        <div *ngFor="let meta of adittionalsMetadatas">
                            <app-custom-control [metadata]="meta" [aditionalsmetadatas]="adittionalsMetadatas"
                                (valueSet)="updateAditionalMetadata($event)">
                            </app-custom-control>
                        </div>
                    </div>
                    <!-- Overlay de carga: dentro de .add-menu-form-body (no de
                         .docs-drop-preview) para bloquear sólo el formulario mientras se
                         guarda, dejando visible el preview del archivo (zoom, labels). -->
                    <div class="load-window message" *ngIf="inProcess">
                        <mat-progress-spinner style="z-index: 1" mode="indeterminate" color="primary">
                        </mat-progress-spinner>
                        <h3 class="primary-text">{{'process.wayOfSigning.loadingTitle' | transloco}}</h3>
                        <span>{{'process.wayOfSigning.loadingSubtitle' | transloco}}</span>
                    </div>
                </div>
                <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                @defer (when rrhhUploadFile && usingFormio) {
                <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                @if (rrhhUploadFile && usingFormio && !((files != null && files.length) || fileBlob != null)) {
                <app-formio-cardinal [haveCloseAction]="true" (submitted)="onSubmitFormio($event)" [formName]="formName"
                    [fileDocument]="documentation">
                </app-formio-cardinal>
                }
                }
                <div class="preview-container" *ngIf="fileImage || isZip">
                    <div class="preview-container" *ngIf="fileValidPreview(); else elseBlock">
                        <img src="{{fileImage}}" [alt]="'process.addDocumentation.documentPreviewAlt' | transloco" />
                    </div>
                    <ng-template #elseBlock>
                        <h4>{{'process.wayOfSigning.errorCode' | transloco}}</h4>
                    </ng-template>
                </div>
                <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                <app-file-document-detail [showFileDocumentHeader]="false" [doc]="documentation" [filePdf]="fileBase64"
                    [showMetadatas]="false" [showWelcome]="false" [showPrint]="false" [fileBlob]="fileBlob"
                    [showSave]="false" [showAll]="false" [showDelete]="false"
                    *ngIf="!analyzingPdf && ((!fileImage && !isZip && files != null && files.length) || fileBlob != null)">
                </app-file-document-detail>
            </div>
            <div style="height: 100px !important;" class="add-menu-form-actions" fxLayout="row-reverse"
                fxLayoutAlign="space-between end">
                <mat-progress-bar mode="indeterminate" *ngIf="selectedDocumentationTypes?.length > 0 && !formReady">
                </mat-progress-bar>
                <mat-selection-list color="accent">
                    <mat-list-option checkboxPosition="before" [selected]="employeeNotify"
                        (click)="changeNotify($event)" *ngIf="showNotifyOption">
                        {{'process.wayOfSigning.sendMailNotificationBtn' | transloco}}
                    </mat-list-option>
                    <mat-list-option checkboxPosition="before" [selected]="getAddMore()" (click)="chageAddMore()">
                        {{'process.wayOfSigning.endAndSendAnotherBtn' | transloco}}
                    </mat-list-option>
                </mat-selection-list>
                <div fxLayout="row-reverse" fxLayoutAlign="start center">
                    <button mat-raised-button color="accent" (click)="submit(stepper)"
                        [disabled]="inProcess || !formReady || analyzingPdf || pdfAnalysisStatus === 'block' || pdfAnalysisStatus === 'review'">{{'common.endBtn'
                        | transloco}}</button>
                    <button mat-button *ngIf="showBack" (click)="back(stepper)">{{'common.lastBtn' |
                        transloco}}</button>
                    <button mat-button *ngIf="!showBack" (click)="cancel()">{{'common.cancelBtn' | transloco}}</button>
                </div>
            </div>
        </form>
    </mat-step>
</mat-horizontal-stepper>
<!-- APP SEARCH MENU -->
<mat-menu #menu="matMenu" xPosition="before" yPosition="below" class="menu-options mat-card">
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <div class="container" (click)="$event.stopPropagation()" fxLayout="column" fxLayoutAlign="start stretch">
        <app-advanced-employee-search [filters]="employeeFilters" [containerType]="containerType"
            (OnFilter)="filteredSearch('Enter')" [uniqueOption]="true">
        </app-advanced-employee-search>
    </div>
    <div class="footer" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="16px">
        <button mat-raised-button color="primary" (click)="filteredSearch('Enter')">{{'common.searchBtn' |
            transloco}}</button>
        <button mat-button>{{'common.closeBtn' | transloco}}</button>
    </div>
</mat-menu>